<script lang="ts">
	import { currentPoints, points, scores } from './stores/scores';
	import Score from "./components/Score.svelte";
	import { flip } from 'svelte/animate';
	import Points from './components/Points.svelte';
</script>

<h1>Eurovision Scoreboard</h1>

<main>
	<ul class="scoreboard">
		{#each $scores.sort((a, b) => a.points === b.points ? (a.name >= b.name ? 1 : -1) : (a.points > b.points ? -1 : 1)) as score, idx (score.flag)}
			<li animate:flip={{delay: 500, duration: 1000}} style="z-index: {100 - idx}">
				<Score flag={score.flag} />
			</li>
		{/each}
	</ul>
	{#if $currentPoints < 10}
		<Points />
	{:else}
		<button on:click={() => currentPoints.set(0)}>Next country</button>
	{/if}
</main>

<style>
	h1 {
		background-color: rgba(2, 7, 36, 0.7);
		border-radius: 0.5rem;
		color: white;
		margin: 1rem auto;
		margin-top: 2rem;
		max-width: 70rem;
		padding: 0.5rem 0;
		text-align: center;
		text-transform: uppercase;
	}

	main {
		background-color: rgba(2, 7, 36, 0.7);
		border-radius: 0.5rem;
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		max-width: 70rem;
		padding-bottom: 0.5rem;
	}

	li {
		width: 50%;
	}

	.scoreboard {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		gap: 0.5rem;
		list-style: none;
		margin: 0;
		max-height: calc(13 * 3.75rem);
		padding: 1rem 1.5rem 0.5rem 1rem;
	}

	button {
		background-color: rgb(0, 50, 126);
		color: white;
		cursor: pointer;
		margin: 1rem;
	}

	@media (max-width: 70rem) {
		li {
			width: 100%;
		}

		.scoreboard {
			max-height: unset;
		}
	}
</style>
